import { useQuery } from '@tanstack/react-query'
import { getGetProductDetailQueryKey, getProductDetail } from '@/apis/rest/generated/hooks'

interface UseQueryProductDetailProps {
  productId: number
  promotionId?: number
}

export const useQueryProductDetail = ({ productId, promotionId }: UseQueryProductDetailProps) => {
  const queryKey = getGetProductDetailQueryKey(productId, promotionId ? { promotionId } : {})
  const queryFn = () => getProductDetail(productId, promotionId ? { promotionId } : {})

  const { data, error, isLoading } = useQuery(queryKey, queryFn, {
    enabled: !!productId,
  })

  return { data, error, isLoading }
}
